import { catalogItemMatchesLine } from "@common/helpers/catalogItemLineMatch";
import { CatalogItem } from "@common/types/catalogItem";
import {
    buildCatalogItemLinePatch,
    toCatalogItemSelection,
} from "@components/invoices/NativeInvoiceDrawer/catalogItemSelection.helpers";
import { NativeInvoiceLineRow } from "@components/invoices/NativeInvoiceDrawer/nativeInvoiceFormTypes";

export function suggestedCatalogItem({
    items,
    line,
}: {
    items: readonly CatalogItem[];
    line: NativeInvoiceLineRow;
}): CatalogItem | null {
    if (line.catalogItemId) {
        return null;
    }
    const matchLine = {
        item: line.productOrService,
        description: line.description,
        unitAmount: line.unitAmount,
    };
    return (
        items.find((item) =>
            catalogItemMatchesLine({ item, line: matchLine }),
        ) ?? null
    );
}

export function acceptedCatalogItemPatch({
    line,
    item,
}: {
    line: NativeInvoiceLineRow;
    item: CatalogItem;
}): Partial<NativeInvoiceLineRow> {
    const selection = toCatalogItemSelection(item);
    return {
        ...buildCatalogItemLinePatch(selection),
        description: item.description ?? line.description,
        classIds:
            selection.classIds.length > 0 ? selection.classIds : line.classIds,
        receivablesAccountId:
            item.receivablesAccountId ?? line.receivablesAccountId,
    };
}
